// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609282304/js/" + chunkId + "." + {"44":"a9a3d159","225":"1a18aeb3","481":"b5fe6ee0","486":"b0b81b4f","770":"e6e7187b"}[chunkId] + ".0.5434668891834333.chunk.js";
};